<template>
  <div style="background-color:#e8e8e8">
    <v-divider />
    <v-container :class="$store.state.mobile ? 'mb-4' : ''">
      <v-row
        justify="space-between"
        :class="$store.state.mobile ? 'flex-column' : ''"
      >
        <v-col
          cols="auto"
        >
          <v-img
            :src="$store.state.webConfig.logo"
            :width="$store.state.mobile ? 140 : 177"
            :height="$store.state.mobile ? 50 : 64"
            class="mt-4"
            :class="$store.state.mobile ? 'mx-auto mb-4' : ''"
          />
          <div
            class="my-3"
            :class="$store.state.mobile ? 'text-center' : ''"
          >
            <router-link
              to="/"
              class="hopper"
              :class="$store.state.mobile ? 'mx-5' : 'me-4'"
            >
              <v-icon
                color="#1a4a96"
                :size="$store.state.mobile ? '30px' : '24px'"
              >
                mdi-facebook
              </v-icon>
            </router-link>
            <router-link
              to="/"
              class="hopper"
              :class="$store.state.mobile ? 'mx-5' : 'me-4'"
            >
              <v-icon
                color="#02abf0"
                :size="$store.state.mobile ? '30px' : '24px'"
              >
                mdi-twitter
              </v-icon>
            </router-link>
            <router-link
              to="/"
              class="hopper"
              :class="$store.state.mobile ? 'mx-5' : 'me-4'"
            >
              <v-icon
                color="#fd0002"
                :size="$store.state.mobile ? '30px' : '24px'"
              >
                mdi-youtube-tv
              </v-icon>
            </router-link>
          </div>
        </v-col>
        <v-col
          cols="auto"
          :class="$store.state.mobile ? 'py-0' : ''"
        >
          <v-expansion-panels
            accordion
            flat
            :readonly="!$store.state.mobile"
            :mandatory="!$store.state.mobile"
          >
            <v-expansion-panel style="background-color:transparent">
              <v-expansion-panel-header
                class="text-h5 grey--text text--darken-3 font-medium  text-uppercase pa-0"
                :expand-icon="$store.state.mobile ? 'mdi-chevron-down' : ''"
                :class="$store.state.mobile ? 'font-weight-bold' : ''"
              >
                <template v-if="$store.getters.languageGetter === '1'">
                  قائمة المنتجات
                </template>
                <template v-else>
                  Products
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div
                  v-for="item in categories.data"
                  :key="item.id"
                  class="mb-2 cursor-pointer grey--text text--darken-1"
                  @click="navigateToGoodsList(item)"
                >
                  {{ $store.getters.languageGetter === '1' ? item.dnames : item.dnamesEn }}
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
        <v-col
          v-for="item in infoListData"
          :key="item.categoryId"
          cols="auto"
          :class="$store.state.mobile ? 'py-0' : ''"
        >
          <v-expansion-panels
            accordion
            flat
            :readonly="!$store.state.mobile"
            :mandatory="!$store.state.mobile"
          >
            <v-expansion-panel style="background-color:transparent">
              <v-expansion-panel-header
                class="text-h5 grey--text text--darken-3 font-medium  text-uppercase pa-0"
                :expand-icon="$store.state.mobile ? 'mdi-chevron-down' : ''"
                :class="$store.state.mobile ? 'font-weight-bold' : ''"
              >
                {{ $store.getters.languageGetter === '1' ? item.categoryName : item.categoryNameEn }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <router-link
                  v-for="subitem in item.child"
                  :key="subitem.id"
                  class="d-block mb-2 grey--text text--darken-1"
                  :to="{ name: 'InformationContent', params: { title: $store.getters.languageGetter === '1' ? subitem.dnames : subitem.dnamesEn, id: subitem.id } }"
                >
                  {{ $store.getters.languageGetter === '1' ? subitem.dnames : subitem.dnamesEn }}
                </router-link>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
        <v-col
          cols="auto"
          :class="$store.state.mobile ? 'py-0' : ''"
        >
          <v-expansion-panels
            accordion
            flat
            :readonly="!$store.state.mobile"
            :mandatory="!$store.state.mobile"
          >
            <v-expansion-panel style="background-color:transparent">
              <v-expansion-panel-header
                class="text-h5 grey--text text--darken-3 font-medium  text-uppercase pa-0"
                :expand-icon="$store.state.mobile ? 'mdi-chevron-down' : ''"
                :class="$store.state.mobile ? 'font-weight-bold' : ''"
              >
                <template v-if="$store.getters.languageGetter === '1'">
                  معلومات الاتصال بالشركة
                </template>
                <template v-else>
                  CONTACT US
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="grey--text text--darken-1">
                <div class="mb-2 d-flex">
                  <div class="me-1">
                    <template v-if="$store.getters.languageGetter === '1'">
                      اسم الشركة:
                    </template>
                    <template v-else>
                      Company:
                    </template>
                  </div> {{ $store.getters.languageGetter === '1' ? webConfig.companyName : webConfig.companyNameEn }}
                </div>
                <div class="mb-2 d-flex">
                  <div class="me-1">
                    <template v-if="$store.getters.languageGetter === '1'">
                      الهاتف:
                    </template>
                    <template v-else>
                      Tel:
                    </template>
                  </div> {{ webConfig.tel }}
                </div>
                <div class="mb-2 d-flex">
                  <div class="me-1">
                    <template v-if="$store.getters.languageGetter === '1'">
                      هاتف محمول:
                    </template>
                    <template v-else>
                      Mob:
                    </template>
                  </div> {{ webConfig.mobile }}
                </div>
                <div class="mb-2 d-flex">
                  <div class="me-1">
                    <template v-if="$store.getters.languageGetter === '1'">
                      البريد الإلكتروني:
                    </template>
                    <template v-else>
                      E-mail:
                    </template>
                  </div> {{ webConfig.email }}
                </div>
                <div class="mb-2 d-flex">
                  <div class="me-1">
                    <template v-if="$store.getters.languageGetter === '1'">
                      عنوان الشركة:
                    </template>
                    <template v-else>
                      Add:
                    </template>
                  </div> {{ $store.getters.languageGetter === '1' ? webConfig.addressPart : webConfig.addressPartEn }}
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
        <v-col
          cols="auto"
        >
          <v-img
            :src="require('@/assets/erweima.png')"
            :class="$store.state.mobile? 'mx-auto' : ''"
            width="126"
            height="126"
          />
        </v-col>
      </v-row>
    </v-container>
    <div class="grey darken-4 white--text">
      <v-container class="text-center">
        <template v-if="$store.getters.languageGetter === '1'">
          حقوق النشر © 2021
          سدة الخليج للتجارة
          جميع الحقوق محفوظة POWERED BY Jiuyu Technology
        </template>
        <template v-else>
          Copyright © 2021
          SADDAT ALKHALEEJ TRADING
          All Rights Reserved POWERED BY Jiuyu Technology
        </template>
      </v-container>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'Footer',
  computed: {
    ...mapState('information', ['infoList']),
    ...mapState(['webConfig', 'categories']),
    infoListData() {
      return this.infoList.data.slice(0, 2);
    },
  },
  created() {
    this.getInfoListAsync();
  },
  methods: {
    ...mapActions('information', ['getInfoListAsync']),
    navigateToGoodsList(item) {
      this.$store.commit('goods/RESET_GOODS_LIST');
      this.$router.push({
        name: 'GoodsList',
        query: {
          categoryId: item.id,
          categoryName: item.dnames,
          categoryNameEn: item.dnamesEn,
          p: 1,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.hopper {
  position: relative;
  top: 0;
  transition: all 0.2s ease-in-out;

  &:hover {
    top: -5px;
  }
}
</style>
